export { SearchLayout as default } from './SearchLayout'
